import { useMemo } from 'react';

import { StatType } from 'services/stats';
import useStats from 'hooks/useStats';

import { formatDuration, localToUtcTs } from 'helpers/date';

export const ProcessDirection = {
  LOAD: 'LOAD',
  UNLOAD: 'UNLOAD',
};

const useProcessStats = (processDir, locationId, dateRange = { start: null, end: null }) => {
  const statType = processDir === ProcessDirection.LOAD ? StatType.loadStats : StatType.unloadStats;
  const stats = useStats(statType, {
    direction: processDir,
    location_id: locationId,
    from: dateRange.start ? localToUtcTs(dateRange.start.toDate(), true) : null,
    to: dateRange.end ? localToUtcTs(dateRange.end.toDate(), true) : null,
  }, {
    initialStats: {
      stats: [],
      summary: {},
    },
    autoFetch: true,
  });

  const statsSummary = useMemo(() => {
    const { summary = {} } = stats.state.stats;
    return {
      boxesUnloaded: (summary.tot_boxes || 0).toFixed(0),
      totContainers: (summary.tot_containers || 0).toFixed(0),
      avgContainerTime: formatDuration((summary.avg_time_per_container || 0) * 3600000, false),
      avgBoxPerMin: (summary.boxes_per_min || 0).toFixed(2),
      avgCph: (summary.avg_cph || 0).toFixed(0),
    };
  }, [stats.state.stats]);

  return {
    isLoading: stats.state.isLoading,
    stats,
    statsSummary,
  };
};

export default useProcessStats;